const baseTextFieldRegExp = /^[a-zA-Z\d\-&\s/]+$/g;
const descriptionTextFieldRegExp = /[\][<>()@=+";]/g;
const emailRegExp =
  /^(([^<>()[\]=.,;:\s@'"]+(\.[^<>()[\]=.,;:\s@'"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

export { baseTextFieldRegExp, descriptionTextFieldRegExp, emailRegExp };
